<select id='paginationDropdownPages' *ngIf="!(totalItems <= pageSizes[0])" name="pageSize" [(ngModel)]="currentPageSize" class="form-control">
  <option *ngFor="let size of pageSizes; index as i" [value]="size" [selected]="size === currentPageSize">{{ size }}</option>
</select>

<ch-pagination
  [totalItems]="totalItems"
  [pageNumber]="pageNumber"
  [pageSize]="currentPageSize"
  (pageChanged)="onPageChanged($event)"
></ch-pagination>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/pagination-dropdown/pagination-dropdown.component.html